import angular from 'angular';
// import controlDataService from '../data/control.data.service';
import ISharedModelService from './ISharedModel.service';


let _$filter;
// let _controlDataService;

export class assetSharedModelService extends ISharedModelService {
  constructor(
    $filter,
    // controlDataService, // eslint-disable-line no-shadow
  ) {
    super('am');
    _$filter = $filter;
    // _controlDataService = oversightDataService;

    this.AssetCriticalities = null;

    this.AssetDataTypes = null;

    this.AssetDataUses = null;

    console.log('app.services.adminAssetSharedModelService created');
  }

  /** ********************************************************************************************
   *  ********************************************************************************************
   *  ********************************************************************************************
   * CRUD Operations
   *
   */

  /** ******************************************
   * Agenda CATEGORIES
   */

  /* getAgendaCategories(agendaId) { // , forceRefresh = false) {
    // if (forceRefresh || !this.cache.am.findingCategories[auditId]) {
    // this.cache.am.findingCategories[auditId] = _amDataService.getFindingCategoriesByAudit(auditId)
    return _oversightDataService.getAgendaCategoriesByAgenda(agendaId)
      .then(response => response.data.result);
    // }
    // return this.cache.am.findingCategories[auditId];
  }

  getAgendaCategoryItems(categoryId) { // , forceRefresh = false) {
    return _oversightDataService.getAgendaCategoryItems(categoryId, true)
      .then(response => response.data.result);
  }

  getAgendaCategorySubItems(itemId) { // , forceRefresh = false) {
    return _oversightDataService.getAgendaCategorySubItems(itemId)
      .then(response => response.data.result);
  } */


  /**
   *
   * @param collection - array of object with canView property
   * @param {Object} propertyObject - Object containing the property to search and the desired value
   * @returns {Array<Object>}
   */
  filterByProperty(collection, propertyObject) {
    return _$filter('filter')(collection, propertyObject);
  }

  addSeverityDescriptionsToRisks(initialRiskTypes) {
    return initialRiskTypes.map(
      (riskType) => {
        if (
          riskType.customerRiskType.inherentRiskSeverityRating >= 1
          && riskType.customerRiskType.inherentRiskSeverityRating < 3
        ) {
          riskType.customerRiskType.inherentRiskSeverityRatingDescription = 'Least';
          riskType.customerRiskType.inherentSeverityMeterLevel = 1;
          riskType.customerRiskType.inherentSeverityCssClass = 'status-tier-bar--great';
        } else if (
          riskType.customerRiskType.inherentRiskSeverityRating >= 3
          && riskType.customerRiskType.inherentRiskSeverityRating < 6
        ) {
          riskType.customerRiskType.inherentRiskSeverityRatingDescription = 'Minimal';
          riskType.customerRiskType.inherentSeverityMeterLevel = 2;
          riskType.customerRiskType.inherentSeverityCssClass = 'status-tier-bar--good';
        } else if (
          riskType.customerRiskType.inherentRiskSeverityRating >= 6
          && riskType.customerRiskType.inherentRiskSeverityRating < 9
        ) {
          riskType.customerRiskType.inherentRiskSeverityRatingDescription = 'Moderate';
          riskType.customerRiskType.inherentSeverityMeterLevel = 3;
          riskType.customerRiskType.inherentSeverityCssClass = 'status-tier-bar--caution';
        } else if (
          riskType.customerRiskType.inherentRiskSeverityRating >= 9
          && riskType.customerRiskType.inherentRiskSeverityRating < 12
        ) {
          riskType.customerRiskType.inherentRiskSeverityRatingDescription = 'Significant';
          riskType.customerRiskType.inherentSeverityMeterLevel = 4;
          riskType.customerRiskType.inherentSeverityCssClass = 'status-tier-bar--bad';
        } else if (
          riskType.customerRiskType.inherentRiskSeverityRating >= 12
          && riskType.customerRiskType.inherentRiskSeverityRating < 15
        ) {
          riskType.customerRiskType.inherentRiskSeverityRatingDescription = 'Most';
          riskType.customerRiskType.inherentSeverityMeterLevel = 5;
          riskType.customerRiskType.inherentSeverityCssClass = 'status-tier-bar--terrible';
        }
        return riskType;
      }
    );
  }

  addProbabilityCssClassesToRiskTypes(initialRiskTypes) {
    const classMappings = {
      5: 'status-tier-bar--terrible',
      4: 'status-tier-bar--bad',
      3: 'status-tier-bar--caution',
      2: 'status-tier-bar--good',
      1: 'status-tier-bar--great',
    };
    return initialRiskTypes.map(
      (riskType) => {
        const cssClass = classMappings[riskType.customerRiskType.riskProbability.score];
        riskType.customerRiskType.riskProbabilityCssClass = cssClass;
        return riskType;
      }
    );
  }
}

assetSharedModelService.$inject = [
  '$filter',
  // 'oversightDataService',
];

export default angular.module('app.services.assetSharedModelService', [
  // oversightDataService,
])
  .service('assetSharedModelService', assetSharedModelService)
  .name;
